import $ from 'jquery';

// Hilfsfunktion zum Escapen von HTML
function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

export default {
    initAccordionTab: function () {
        //code by claude.ai
        $('.frame-type-list.frame-layout-2 .tx-tinyaccordion-pi1 .tinyaccordion li').each(function () {
            const $container = $(this);
            const $accSection = $container.find('.acc-section');

            // Tab-wrapper nur einmal hinzufügen
            $accSection.prepend('<div class="tab_wrapper"></div>');
            const $tabWrapper = $accSection.find('.tab_wrapper');

            // Alle Textpic-Elemente auf einmal sammeln
            const $textpicElements = $accSection.find('.frame-type-textpic');

            // Arrays für Batch-Updates vorbereiten
            const tabsHTML = [];

            $textpicElements.each(function (index) {
                const $element = $(this);
                const tabIndex = index + 1;
                const isActive = tabIndex === 1;
                const activeClass = isActive ? 'active' : '';

                // Klassen in einem Zug setzen
                $element.addClass(`item element-${tabIndex} ${activeClass}`.trim());

                // Tab-HTML sammeln statt einzeln zu appendieren
                const tabTitle = $element.find('header h2').text() || ''; // text() statt html() für bessere Performance
                if (tabTitle) {
                    tabsHTML.push(`<div class="tab ${activeClass}" data-target="element-${tabIndex}">
                        <p>${escapeHtml(tabTitle)}</p>
                    </div>`);
                }
            });

            // Alle Tabs auf einmal einfügen (bessere Performance)
            if (tabsHTML.length > 0) {
                $tabWrapper.html(tabsHTML.join(''));
            }

            // Event-Delegation für bessere Performance
            $container.on('click', '.tab', function (e) {
                e.preventDefault();

                const $clickedTab = $(this);
                const targetClass = $clickedTab.data('target');

                // Alle Tabs und Elemente deaktivieren
                $container.find('.tab, .frame-type-textpic').removeClass('active');

                // Geklickten Tab und zugehöriges Element aktivieren
                $clickedTab.addClass('active');
                $container.find(`.${targetClass}`).addClass('active');

            });
        });
    }
}